import { NgModule } from '@angular/core';
import { SharedMaterialModule } from 'core-client/api';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  imports: [SharedMaterialModule, DragDropModule],
  exports: [SharedMaterialModule, DragDropModule]
})
export class SharedModule { }
